<template>
    <div class="map-container-height">
        <!--Will Not Toggle Properly if put into a class...Leave inline-->
        <div @dblclick="zoomIn" @contextmenu="zoomOut" style="width: 50vw; height: 100%;" id='taskDetailsMap'></div>
    </div>
</template>

<script>
    import mapboxgl from 'mapbox-gl';
    import mapHelpers from '../../utils/helpers/mapHelpers'

    export default {
        name: 'task-details-map',
        props: {
            jobTask: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                map: null,
                accessToken: 'pk.eyJ1IjoiaG9za2luc3QiLCJhIjoiY2s5M2N6NHprMDEwNDNkbWJieThzbm1hNiJ9.0F7I8B6DKLxTzAXg1oN9Hw',
                mapStyle: 'mapbox://styles/mapbox/outdoors-v12',
                editTaskDialog: false,
                currentMarkers: [],
                clickCounter: 0
            }
        },
        mounted() {
            this.createMap();
        },
        methods: {
            createMap() {
                mapboxgl.accessToken = this.accessToken
                // init the map
                this.map = new mapboxgl.Map({
                    container: 'taskDetailsMap',
                    style: this.mapStyle,
                    center: [this.jobTask.longitude ? this.jobTask.longitude : -122.9110, this.jobTask.latitude ? this.jobTask.latitude : 49.2057],                     zoom: 13
                })
                this.map.on('load', () => {
                    this.map.resize();
                });
                this.map['doubleClickZoom'].disable()
                this.map.addControl(new mapboxgl.NavigationControl());
                this.map.addControl(
                    new mapboxgl.GeolocateControl({
                        positionOptions: {
                            enableHighAccuracy: true
                        },
                        showAccuracyCircle: false,
                        trackUserLocation: true
                    })
                );
                this.addMarker()

            },
            zoomIn() {
                let z = this.map.getZoom()
                this.map.flyTo({ zoom: z + 2, speed: 0.2, curve: 1, essential: true })
            },
            zoomOut (e) {
                e.preventDefault()
                this.clickCounter++
                if (this.clickCounter === 2) {
                    let z = this.map.getZoom()
                    this.map.flyTo({ zoom: z - 2, speed: 0.2, curve: 1, essential: true })
                    this.clickCounter = 0
                }
            },
            addMarker() {
                if (this.currentMarker) {
                    this.currentMarker.remove()
                }
                if(!this.jobTask.longitude || !this.jobTask.latitude){
                    return
                }

                const lat = this.jobTask.latitude;
                const lon = this.jobTask.longitude;
                const openStreetView = `window.open('https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lon}')`
                const button = `<button onclick="${openStreetView}">Open street view</button>`;

                let popup = new mapboxgl.Popup({ closeOnClick: false, offset: 10 })
                    .setHTML(`<h5>${this.jobTask.address}</h5>${button}`);

                // Tasks requiring a flagger should have their icon background changed to a shade of blue
                const tagNames = this.jobTask.jobTaskTags.map((tag) => tag.tag.name);
                const requiresFlagger = tagNames.includes('Requires Flagger');
                const element = mapHelpers.getElement(mapHelpers.parseType(this.jobTask));
                const currentColor = element.style.backgroundColor;
                const flaggerColor = this.$vuetify.theme.themes.light.flagger;
                element.style.backgroundColor = (requiresFlagger) ? flaggerColor : currentColor;

                this.currentMarker = new mapboxgl.Marker({
                    element: element
                })
                    .setLngLat([this.jobTask.longitude, this.jobTask.latitude])
                    .setPopup(popup)
                    .addTo(this.map)
                    .togglePopup()
                this.map.flyTo({ center: [this.jobTask.longitude, this.jobTask.latitude] })
                this.map.resize()
            },
        },
        watch: {
            jobTask() {
                this.createMap()
            }
        }
    }
</script>
<style>
    .map-container-height{
        height: 100%;
    }
    .mapboxgl-ctrl-top-right .mapboxgl-ctrl {
        margin: 14px 12px 0 0 !important;
    }
    .mapboxgl-canvas {
        height: 100% !important;
    }
    .mapboxgl-marker:hover {
        cursor: pointer;
    }
    .marker-general {
        background-size: cover;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        cursor: pointer;
        background-color: white
    }
    .marker-bigger {
        background-size: cover;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        cursor: pointer;
        background-color: white
    }
    .marker-pin-overhead {
        background-image: url('../../assets/markerIcons/pin-oh.png');
    }
    .marker-pin-underground {
        background-image: url('../../assets/markerIcons/pin-ug.png');
    }
    .marker-pin-unknown {
        background-image: url('../../assets/markerIcons/pin-unk.png');
    }
    .marker-two-trip-overhead {
        background-image: url('../../assets/markerIcons/twotrip-oh.png');
    }
    .marker-two-trip-underground {
        background-image: url('../../assets/markerIcons/twotrip-ug.png');
    }
    .marker-two-trip-unknown {
        background-image: url('../../assets/markerIcons/twotrip-unk.png');
    }
    .marker-meet {
        background-image: url('../../assets/markerIcons/meet.png');
        background-color: #5a5a5a
    }
    .marker-demo {
        background-image: url('../../assets/markerIcons/volcano.png');
    }
    .marker-on-after {
        background-image: url('../../assets/markerIcons/alert.png');
    }
    .marker-rush {
        background-image: url('../../assets/markerIcons/fire.png');
    }
    .marker-confined {
        background-image: url('../../assets/markerIcons/confined.png');
    }
</style>
